import { Component, Input } from '@angular/core';

@Component({
  selector: 'md-icon-radio-button',
  template: require('./icon-radio-button.component.html'),
  styles: [require('./icon-radio-button.component.scss')]
})

export class IconRadioButtonComponent {
  @Input() option;
  @Input() isValid;
  @Input() isSelected;
}
